import mod from "-!./Footer.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Footer.js?vue&type=script&lang=js&"